var arrayFrom = require('array-from');

import { triggerElementEvent } from "./Events";

class FakeEvent{
    constructor( originalEvent ){
        this.target = originalEvent.target;
        this.currentTarget = originalEvent.currentTarget;
        this.originalEvent = originalEvent;

        return this;
    }

    stopPropagation (){
        return this.originalEvent.stopPropagation();
    }

    preventDefault (){
        return this.originalEvent.preventDefault();
    }
}

function _checkElementChildEventCallbacks( rootElement, eventName, childSelector, originalEvent ){
    var event = new FakeEvent(originalEvent);
    var target = originalEvent.target;

    // Check all the closest targets
    var selectors = rootElement._childSelectorEvents[eventName];

    for(var i = 0; i < selectors.length; i++){

        var closest = target.closest(selectors[i].selector);
        if( closest ) {
            event.currentTarget = closest;
            if(selectors[i].callbacks){
                // Run all callbacks registered for this child selector
                selectors[i].callbacks.map( (func) => {
                    func(event);
                });
            }

            if(originalEvent.cancelBubble){
                return false;
            }
        }
    }
}

function onChildSelectorEvent( rootElement, eventName, childSelector, callback){
    if(!rootElement._childSelectorEvents){
        rootElement._childSelectorEvents = {};
    }

    if(!rootElement._childSelectorEvents[eventName]){
        rootElement._childSelectorEvents[eventName] = [];

        rootElement.addEventListener(eventName, function(originalEvent){
            return _checkElementChildEventCallbacks(rootElement, eventName, childSelector, originalEvent );
        });
    }

    // Check if we have existing object for this childSelector
    let found;
    rootElement._childSelectorEvents[eventName].map( (item) => {
        if(item.selector === childSelector){
            found = item;
        }
    });

    if(found){
        found.callbacks.push( callback );
    }else{
        var item = {selector: childSelector, callbacks: [ callback ]};
        rootElement._childSelectorEvents[eventName].push( item );
    }
}

function offChildSelectorEvent( rootElement, eventName, childSelector, callback){
    if(!rootElement._childSelectorEvents || !rootElement._childSelectorEvents[eventName]){
        return;
    }

    // Check all the closest targets
    var selectors = rootElement._childSelectorEvents[eventName];

    selectors = selectors.filter( (selector) => {
        if(selector.selector === childSelector){
            if(!callback){
                selector.callbacks.length = 0; // Empty array
                return false; // Remove this from the filter
            }else{
                selector.callbacks = selector.callbacks.filter( (func) => {
                    return callback !== func;
                });

                return selector.callbacks.length; // If we still have callbacks, return this in the filter
            }
        }else{
            return true;
        }
    });


    rootElement._childSelectorEvents[eventName] = selectors;
}


export class FakeQuery{
    constructor (elements){
        if(elements instanceof Array){
            this.elements = elements;
        }else if( elements instanceof FakeQuery ){
            return elements; // Just return the input if it is already a FakeQuery class
        }else if ( typeof elements === "string" ){
            var tempElement = document.createElement("div");
            tempElement.insertAdjacentHTML("beforeend", elements);
            this.elements = arrayFrom( tempElement.children);
        }else if(typeof elements === "undefined"){
            this.elements = [];
        }else if(elements === null){
            this.elements = [];
        }else{
            this.elements = [elements];
        }
    }

    get (){
        var args = arrayFrom(arguments);
        if(args.length){
            return this.elements[args[0]];
        }else{
            return this.elements;
        }
    }

    on (eventName, callback){
        var args = arrayFrom(arguments);
        var eventNames = this._splitSpacedString(args[0]);

        if(eventNames.length > 1){
            eventNames.map ( (event) => {
                // Recursively run this .on() with the same arguments, except only with the single event name
                var newArgs = [].concat(args);
                newArgs[0] = event;
                this.on.apply(this, newArgs );
            } );
            return this;
        }else if(eventNames.length === 0){
            return this;
        }else if(eventNames.length === 1){

            if(args.length === 2){
                this.elements.map( (element) => {
                    element.addEventListener(eventName, callback);
                });
            }else if(args.length === 3){
                this._onChildSelector( args[0], args[1], args[2] );
            }
        }

        return this;
    }

    off (){
        var args = arrayFrom(arguments);
        var eventNames = this._splitSpacedString(args[0]);
        if(eventNames.length > 1){
            throw new Error(".off with multiple spaced events is not implemented yet");
        }
        if(args.length === 2 && typeof args[1] === "function"){
            this.elements.map( (element) => {
                element.removeEventListener(args[0], args[1]);
            });
        }else{
            this._offChildSelector( args[0], args[1], args[2] );
        }
        return this;
    }

    _onChildSelector( eventName, childSelector, callback){
        this.elements.map( (element) => {
            onChildSelectorEvent(element, eventName, childSelector, callback);
        });
    }
    _offChildSelector( eventName, childSelector, callback){
        this.elements.map( (element) => {
            offChildSelectorEvent(element, eventName, childSelector, callback);
        });
    }

    trigger(eventName){
        this.elements.map( (element) => {
            if(element instanceof FakeQuery){
                element.trigger(eventName);
            }else{
                triggerElementEvent(element, eventName);
            }
        });
        return this;
    }

    find(query){
        var elements = this.elements.map( (element) => {
            return arrayFrom( element.querySelectorAll(query) );
        });

        const reducer = (acc, el) => { return acc.concat(el); };

        var els = elements.reduce( reducer, [] ); // [ [1,2], [3], [4,5], [],[],[6,7,8]] => [1,2,3,4,5,6,7,8];
        return $$(els);
    }

    filter(query){
        var found = {};
        this.elements.map( (el) => {
            if(el.matches(query)){
                found = el;
            }
        });

        return $$(found);
    }

    append( appendElement ){
        if(!appendElement){
            // null, false or undefined guard
            return this;
        }

        // basically we need to just recursively get elements out of FakeQuery classes and arrays until we have actual elements
        // For each of the elements in our existing colleciton, append the input
        if( appendElement instanceof FakeQuery ){
            // If we got a FakeQuery input, just run the command again on the elements array
            this.append( appendElement.get() );
        }else if(appendElement instanceof Array){
            // Now if we got an array input, run the append function on all the elements of the array
            appendElement.map( this.append.bind(this) );
        }else{
            // Now if it seems we have gotten something else, we try to append this element to all our local elements
            this.elements.map( (element) => {
                element.appendChild(appendElement);
            });
        }

        return this;
    }

    show ( forceDisplay ) {
        this.elements.map( (el) => { el.style.display = forceDisplay ? forceDisplay : ""; });
        return this;
    }

    hide () {
        this.elements.map( (el) => { el.style.display = "none"; });
        return this;
    }

    _splitSpacedString (classesString) {
        return classesString.split(" ")
        .map( (str) => { return str.trim() })
        .filter( (str) => { return str.length > 0 });
    }

    addClass (classesString) {
        var classes = this._splitSpacedString(classesString);
        this.elements.map( (el) => {
            classes.map ( (cls) => {
                el.classList.add(cls);
            } );
        });
        return this;
    }

    removeClass (classesString) {
        var classes = this._splitSpacedString(classesString);
        this.elements.map( (el) => {
            classes.map ( (cls) => {
                el.classList.remove(cls);
            });
        });
        return this;
    }

    remove (){
        this.elements.map( (el) => {
            if(el.remove){
                return el.remove();
            }else if (el.parentNode) {
                el.parentNode.removeChild(el);
            }
        });
        return this;
    }

    empty () {
        this.elements.map( (el) => { el.innerHTML = ""; });
        return this;
    }

    focus () {
        this.elements.map( (el) => { el.focus() });
        return this;
    }

    blur () {
        this.elements.map( (el) => { el.blur() });
        return this;
    }

    attr ( ){
        var args = arrayFrom(arguments);
        if(args.length === 2){
            this.elements.map( (el) => {
                el.setAttribute(args[0], args[1]);
            });
            return this;
        }else{
            var attrs = this.elements.map( (el) => {
                return el.getAttribute(args[0]);
            });
            return attrs.length && attrs[0];
        }
    }

    html ( content ){
        if(typeof content !== "undefined"){
            this.elements.map( (el) => {
                el.innerHTML = content;
            });
            return this;
        }else{
            var html = "";
            this.elements.map( (el) => {
                html += el.innerHTML;
            });
            return html;
        }
    }

    text (){
        var textContent = "";
        this.elements.map( (el) => {
            if(el) textContent += el.textContent;
        });
        return textContent;
    }

    val (t){
        if(typeof t !== "undefined"){
            this.elements.map( (el) => {
                if(el instanceof HTMLTextAreaElement){
                    el.innerHTML = t;
                }else{
                    el.value = t;
                }
            });
            return this;
        }else{
            var val;
            this.elements.map( (el) => {
                val = el.value;
            });
            return val;
        }
    }

    checked (){
        var args = arrayFrom(arguments);
        if(args.length){
            // Given input, we want to set checked state on our element(s)
            this.elements.map( (el) => {
                if(args[0]) {
                    el.checked = true;
                }else{
                    el.checked = false;
                }
            });
            return this;
        }else{
            var checked = !!(this.elements && this.elements[0] && this.elements[0].checked );
            return checked;
        }
    }

    prev (){
        var prev = this.get(0) ? this.get(0).previousElementSibling : {};
        return $$(prev);
    }

    next ( selector ){
        if(selector){
            var element = this.get(0);
            var found = null;
            do{
                let next = element.nextElementSibling;
                if(next && next.matches(selector)){
                    found = next;
                    element = null;
                }else if(next){
                    element = next;
                }else{
                    element = null;
                }

            } while( (found === null) && element )

            return $$(found);
        }else{
            let next = this.get(0) ? this.get(0).nextElementSibling : null;
            return $$(next);
        }
    }

    first (){
        return $$( this.get(0) );
    }

    get length (){
        return this.get().length;
    }

    parent (){
        var el = this.get(0);
        return $$(el ? el.parentNode : null);
    }
}


export function $$( elem ){
    return new FakeQuery(elem);
}


// WEBPACK FOOTER //
// src/utils/FakeQuery.js